// Модель команды или команды друзей (они одинаковы)
import TeamBaseModel from './team-base';

import teamService from '@/services/API/team/index';

import { apiService } from '@/services/APIService';

import { rHandler } from '@/plugins/RHandler';
import { TEAM_TYPES } from '@/modules/Team/constants';

import { DEFAULT_PARAMS } from '@/utils/objectsRHandler';

export default class Team extends TeamBaseModel {
  constructor(team, type) {
    super(team, type);
    // team - команда пришедшая с свервера в сыром виде
    this.responseData = team;

    this.type = type;

    this.hash = team.hash || null;
    this.view_path = `/my-teams/${this.type}/${this.id}/members`;

    this.organizer = team.organizer || null;
    this.subordination_id = team.subordination_id || null;
    this.prize_places = team.prize_places || null;
  }

  /**
   * Доступно ли выполнение заданий или удаление участников в этой команде
   * @param userId: number - default store user
   *
   * @return result: boolean
   */
  hasAdminPermissions(userId = this.user.data.id) {
    return this.isOwner(userId) || this.isCaptain(userId);
  }

  isOwner(userId) {
    return this.owner_id === userId;
  }

  isCaptain(userId) {
    return this.captain_id === userId;
  }

  // NOTE (#trainer): Это юзается единожды где-то, по возможно убрать конструкцию с костылём isCaptain
  async fetchMembers() {
    if (!this.members?.length) return null;
    const response = await this.fetchMembersProfiles();
    this.members.forEach((member) => {
      member.isCaptain = this.isCaptain(member.id);
    });
    return response;
  }

  fetchJoinHash() {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.stageJoinHash,
      [TEAM_TYPES.friends]: teamService.friendsJoinHash,
      [TEAM_TYPES.coaching]: teamService.coachingJoinHash,
    };

    return rHandler(API_METHODS[this.type](this.id), (resp) => {
      this.hash = resp.data.data.hash;
    });
  }

  leave({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.leaveStageTeam,
      [TEAM_TYPES.friends]: teamService.friendsLeave,
      [TEAM_TYPES.coaching]: teamService.coachingLeave,
    };
    return rHandler(
      API_METHODS[this.type](this.id, data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  exclude({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.excludeEventStageMembers,
      [TEAM_TYPES.friends]: teamService.friendsExclude,
      [TEAM_TYPES.coaching]: teamService.coachingExclude,
    };

    return rHandler(
      API_METHODS[this.type](this.id, data),
      (response) => {
        this.members = this.members.filter((i) => !data.user_ids.includes(i.id));
        this.members_count = this.members.length;
        return { response };
      },
      (error) => ({ error }),
    );
  }

  join({ data } = DEFAULT_PARAMS) {
    const API_METHODS = {
      [TEAM_TYPES.team]: teamService.joinByInvitionEventTeam,
      [TEAM_TYPES.friends]: teamService.friendsJoin,
      [TEAM_TYPES.coaching]: teamService.coachingJoin,
    };
    return rHandler(
      API_METHODS[this.type](data),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }

  update(data = null) {
    return rHandler(
      apiService.put(`${this.type}/${this.id}`, data),
      (response) => ({ item: new Team(response.data.data, this.type), response }),
      (error) => ({ error }),
    );
  }

  delete() {
    return rHandler(
      apiService.delete(`${this.type}/${this.id}`),
      (response) => ({ response }),
      (error) => ({ error }),
    );
  }
}
